var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconsGraphSchool(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(14 9)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m28.368 23.902 16.548 12.84V59a3 3 0 0 1-3 3h-32a3 3 0 0 1-3-3V36.741l16.548-12.839a4 4 0 0 1 4.904 0z",
    fill: "#BDD9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.6 11.755 22.246 20.132a3 3 0 0 1 0 4.449l-3.424 3.098a3 3 0 0 1-4.026 0L27.258 24.829a2 2 0 0 0-2.684 0L8.437 39.434a3 3 0 0 1-4.027 0L.987 36.336a3 3 0 0 1 0-4.45l22.245-20.131a4 4 0 0 1 5.368 0z",
    fill: "#3A6CD5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.923 0h9.07a1.605 1.605 0 0 1 1.124 2.75l-1.49 1.463a1.804 1.804 0 0 0 0 2.574l1.49 1.463A1.605 1.605 0 0 1 35.992 11h-9.07a3.006 3.006 0 0 1-3.006-3.006V3.006A3.006 3.006 0 0 1 26.923 0z",
    fill: "#37DC8C"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#5AA0FF",
    x: 18.916,
    y: 48,
    width: 13,
    height: 14,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#5AA0FF",
    x: 18.916,
    y: 31,
    width: 13,
    height: 13,
    rx: 6.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsGraphSchool);
export default __webpack_public_path__ + "static/media/icons_graph_school.8c25dd4662ed448cf13baadda60f4f58.svg";
export { ForwardRef as ReactComponent };